import { ChangeDetectorRef, Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AddCustomerBankAccountComponent } from 'src/app/BankAccount/add-customer-bank-account/add-customer-bank-account.component';
import { BasicDialogComponent } from 'src/app/BaseDialog/basic-dialog/basic-dialog.component';
import { ALERT_TYPE, SUCCESS_MESSAGES } from 'src/app/constants';
import { DialogItem } from 'src/app/dialog-item';
import { SharedService } from 'src/app/Shared/shared-service.service';
import { AccountAuthorization } from 'src/model/accountAuthorization';
import { Customer } from 'src/model/customer.model';
import { CustomerAccount } from 'src/model/customerAccount.model';
import { GlobalCustomer } from 'src/model/globalCustomer.model';
import { AccountAuthorizationService } from 'src/services/accountAuthorization.service';
import { CustomerAccountService } from 'src/services/customer-account.service';

@Component({
	selector: 'app-manage-approved-bank-in-account',
	standalone: false,
	templateUrl: './manage-approved-bank-in-account.component.html',
	styleUrl: './manage-approved-bank-in-account.component.scss'
})
export class ManageApprovedBankInAccountComponent implements OnInit {
	@Output() addedBank = new EventEmitter<CustomerAccount>();
	@Input() selectedCustomer: GlobalCustomer;

	protected activeModal = inject(NgbActiveModal);
	protected sharedService = inject(SharedService);
	protected cdr = inject(ChangeDetectorRef);

	protected acctAuthService = inject(AccountAuthorizationService);
	protected accountService = inject(CustomerAccountService);

	protected disabledSubmit = false;

	protected approvedAccountList: CustomerAccount[] = new Array();

	async ngOnInit(): Promise<void> {
		const authorizations = await this.acctAuthService.getAllAccountAuthorizations([this.selectedCustomer.CustomerID], undefined, undefined);

		const customerAccounts = await this.accountService.getAllCustomerAccounts([this.selectedCustomer.CustomerID]);
		const ownerAccounts = customerAccounts.filter(acc => acc.ContactId == undefined && acc.DisabledOn == undefined);
		this.approvedAccountList.push(...ownerAccounts);

		this.processAccountAuthorizations(authorizations);
	}

	async processAccountAuthorizations(authorizations: AccountAuthorization[]) {
		const approvedCustAcc = authorizations.filter(a => a.RevokedOn == undefined && a.GrantedUntil != undefined && this.sharedService.stripTime(new Date(a.GrantedUntil)) >= this.sharedService.stripTime(new Date())).map(a => a.CustomerAccountId);

		if (approvedCustAcc.length > 0) {
			const approvedGuarantorAccounts = await this.accountService.getAccountsDetails(approvedCustAcc);
			this.approvedAccountList.push(...approvedGuarantorAccounts);
		}
	}

	openAddBankAccountModal() {
    let customer = new Customer();
		customer.ID = this.selectedCustomer.CustomerID;
		customer.Name = this.selectedCustomer.Name;
		customer.ICNumber = this.selectedCustomer.ICNumber;
		customer.CompanyId = this.selectedCustomer.CompanyId;
    const modalRef = this.sharedService.openModal(BasicDialogComponent);
    const i = modalRef.componentInstance as BasicDialogComponent;
    i.title = 'Add Customer Bank Account';
    i.injectContent = [new DialogItem(AddCustomerBankAccountComponent, {customer: customer, isContactAcct: false})];
    modalRef.result.then((acc: CustomerAccount) => {
      if (acc !== undefined) {
		    if (acc.ContactId === undefined)
          this.approvedAccountList.push(acc);
        else
          this.sharedService.openAlert(`${SUCCESS_MESSAGES.ADDED('guarantor bank account')}, please submit authorization request at : CUSTOMER PROFILE > BANK ACCOUNT`, ALERT_TYPE.SUCCESS);
      }
    });
	}

	async addCustomerAccountToParent(acc: CustomerAccount) {
		this.addedBank.emit(acc);
		this.sharedService.openAlert('Successfully submitted company account', ALERT_TYPE.SUCCESS);
		this.reset();
	}

	reset() {
		this.activeModal.close();
	}
}
